var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToggleDayCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "22.088px",
    height: "22.115px",
    viewBox: "14.324 3.442 22.088 22.115",
    enableBackground: "new 14.324 3.442 22.088 22.115",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M25.38,3.442c6.106,0,11.057,4.951,11.057,11.057c0,6.107-4.951,11.059-11.057,11.059 c-6.106,0-11.057-4.951-11.057-11.059l0,0C14.324,8.394,19.274,3.442,25.38,3.442z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-444.879 -433.727)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(546.985 535.728)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8716D",
    stroke: "#E8716D",
    strokeWidth: 0.5,
    d: "M-71.381-80.139c0.804,0.006,1.46-0.641,1.466-1.445v-10.469 c-0.006-0.803-0.662-1.449-1.466-1.444h-10.688c-0.803-0.005-1.459,0.642-1.466,1.444v10.469c0.007,0.805,0.663,1.451,1.466,1.445 H-71.381z M-82.927-81.584v-10.469c0.004-0.47,0.388-0.848,0.858-0.845h10.688c0.47-0.003,0.854,0.375,0.858,0.845v10.469 c-0.004,0.471-0.389,0.85-0.858,0.846h-10.688C-82.539-80.734-82.923-81.113-82.927-81.584L-82.927-81.584z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(550.608 534.362)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8716D",
    stroke: "#E8716D",
    strokeWidth: 0.5,
    d: "M-82.826-90.333v-2.81c0-0.195-0.159-0.354-0.355-0.354 c-0.196,0-0.355,0.159-0.355,0.354v2.81c0,0.196,0.159,0.354,0.355,0.354C-82.985-89.979-82.826-90.137-82.826-90.333z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(556.339 534.362)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8716D",
    stroke: "#E8716D",
    strokeWidth: 0.5,
    d: "M-82.825-90.333v-2.81c0-0.195-0.159-0.354-0.354-0.354 c-0.197,0-0.355,0.159-0.355,0.354v2.81c0,0.196,0.158,0.354,0.355,0.354C-82.984-89.979-82.825-90.137-82.825-90.333z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(547.34 538.457)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -83.535,
    y: -93.498,
    fill: "#E8716D",
    stroke: "#E8716D",
    strokeWidth: 0.5,
    width: 12.833,
    height: 0.71
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(551.908 540.793)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E8716D",
    stroke: "#E8716D",
    strokeWidth: 0.5,
    d: "M-82.066-87.946c0.178,0.08,0.388,0,0.467-0.18c0,0,0,0,0,0 l2.168-4.873c0.08-0.179,0-0.389-0.179-0.469c-0.046-0.021-0.095-0.031-0.146-0.031h-3.424c-0.196,0-0.355,0.159-0.355,0.355 s0.159,0.354,0.355,0.354h2.88l-1.946,4.372c-0.08,0.18-0.001,0.389,0.178,0.469C-82.067-87.946-82.067-87.946-82.066-87.946z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleDayCircle);
export default __webpack_public_path__ + "static/media/toggle-day-circle.7676d474.svg";
export { ForwardRef as ReactComponent };